import { authHeader, handleResponse } from '../helpers';
export const GiftServices = {
  GetAllGifts,
};
// async function GetAllGifts(data) {
//   const url = new URL(`${process.env.REACT_APP_API_URL}Gift/GetGifts`);
//   const requestOptions = {
//     method: 'POST',
//     headers: authHeader(),
//   };
//   try {
//     const response = await fetch(url, requestOptions);
//     return handleResponse(response); // Properly closed parentheses
//   } catch (error) {
//     console.error('API request failed', error);
//     throw error;
//   }
// }
function GetAllGifts(data) {
  const requestOptions = {
      method: 'POST',
      headers: authHeader(),
      body: JSON.stringify(data)
  };

  return fetch(`${process.env.REACT_APP_API_URL}Gift/GetGifts`, requestOptions)
      .then(handleResponse);
}